<template>
  <div class="personal_center park_user">
    <div class="parkSwitch" v-if="auth && parkInfo">
      当前园区：
      {{parkInfo.name}} - {{company}}
      <a href="javascript:;" @click="dialogParams2.dialogVisible = true">切换园区</a>
    </div>
    <div class="m">
      <div class="left_box">
        <el-menu :default-openeds="['1','2','3','4']" :default-active="curActive">
          <el-submenu index="1">
            <template slot="title">
              <i class="iconfont">&#xe63d;</i>
              <span>员工服务</span>
            </template>
<!--            <el-menu-item-group>-->
<!--              <template slot="title">工作管理</template>-->
            <el-menu-item index="1-3">
              <router-link to="/personal_center/park_user/employee_certification">员工认证</router-link>
            </el-menu-item>
              <el-menu-item index="1-1">
                <router-link to="/personal_center/park_user/meeting_room_reservation">会议室预定</router-link>
              </el-menu-item>
              <el-menu-item index="1-2">
                <router-link to="/personal_center/park_user/visitor_registration">访客登记</router-link>
              </el-menu-item>

              <!-- <el-menu-item index="1-4">
                <router-link to="/personal_center/park_user/my_repair">我的报修</router-link>
              </el-menu-item> -->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">交易管理</template>-->
              <el-menu-item index="1-5">
                <router-link to="/personal_center/park_user/my_purchase">我的拼购</router-link>
              </el-menu-item>
<!--              <el-menu-item index="1-6">-->
<!--                <router-link to="/personal_center/park_user/my_order">我的订单</router-link>-->
<!--              </el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">活动管理</template>-->
              <el-menu-item index="1-7">
                <router-link to="/personal_center/park_user/my_enroll">我的报名</router-link>
              </el-menu-item>
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">我的关注</template>-->
              <el-menu-item index="1-8">
                <router-link to="/personal_center/park_user/my_collection">我的收藏</router-link>
              </el-menu-item>
<!--              <el-menu-item index="1-9">-->
<!--                <router-link to>我的足迹</router-link>-->
<!--              </el-menu-item>-->
<!--            </el-menu-item-group>-->
              <el-menu-item index="1-6">
                <router-link to="/personal_center/park_user/my_order">我的订单</router-link>
              </el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="2">
            <template slot="title">
              <i class="iconfont">&#xe604;</i>
              <span>企业服务</span>
            </template>
            <el-menu-item-group>
              <template slot="title">园区服务</template>
              <el-menu-item index="2-1">
                <router-link to="/personal_center/park_user/park_payment">园区缴费(有)(林)</router-link>
              </el-menu-item>
              <el-menu-item index="2-2">
                <router-link to="/personal_center/park_user/overtime_application">加班申请(有)(熊)</router-link>
              </el-menu-item>
              <el-menu-item index="2-3">
                <router-link to="/personal_center/park_user/booking_room">预约看房(林)</router-link>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <template slot="title">认证管理</template>
              <el-menu-item index="2-4">
                <router-link to="/personal_center/park_user/enterprise_certification">企业认证</router-link>
              </el-menu-item>
              <el-menu-item index="2-5">
                <router-link to="/personal_center/park_user/staff_management">员工管理(林)</router-link>
              </el-menu-item>
              <el-menu-item index="2-6">
                <router-link to="/personal_center/park_user/admission_to_the_park">入驻园区</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>-->
          <el-submenu index="3">
            <template slot="title">
              <i class="iconfont">&#xe6cb;</i>
              <span>保障建议</span>
            </template>
            <el-menu-item index="3-1">
              <router-link to="/personal_center/park_user/feedback_suggestions">反馈建议</router-link>
            </el-menu-item>
            <el-menu-item index="3-2">
              <router-link to="/personal_center/park_user/customer_center">客户中心</router-link>
            </el-menu-item>
            <el-menu-item index="3-3">
              <router-link to="/personal_center/park_user/park_notice">园区通告</router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right_box">
        <router-view></router-view>
      </div>
    </div>
    <!-- 切换园区 -->
    <switchPark :dialogParams="dialogParams2" />
  </div>
</template>

<script>
// import api from "@/api/buyer/buyer";
import myTable from "@/components/my_table.vue";
const rouerObj = [
  {
    pathKey: "/personal_center/park_user/meeting_room_reservation",
    index: "1-1"
  },
  {
    pathKey: "/personal_center/park_user/visitor_registration",
    index: "1-2"
  },
  {
    pathKey: "/personal_center/park_user/employee_certification",
    index: "1-3"
  },
  {
    pathKey: "/personal_center/park_user/my_repair",
    index: "1-4"
  },
  {
    pathKey: "/personal_center/park_user/my_purchase",
    index: "1-5"
  },
  {
    pathKey: "/personal_center/park_user/my_order",
    index: "1-6"
  },
  {
    pathKey: "/personal_center/park_user/my_enroll",
    index: "1-7"
  },
  {
    pathKey: "/personal_center/park_user/my_collection",
    index: "1-8"
  },
  // {
  //   pathKey: "/personal_center/park_user/employee_certification",
  //   index: "1-9"
  // },
  // {
  //   pathKey: "/personal_center/park_user/park_payment",
  //   index: "2-1"
  // },
  // {
  //   pathKey: "/personal_center/park_user/overtime_application",
  //   index: "2-2"
  // },
  // {
  //   pathKey: "/personal_center/park_user/booking_room",
  //   index: "2-3"
  // },
  // {
  //   pathKey: "/personal_center/park_user/enterprise_certification",
  //   index: "2-4"
  // },
  // {
  //   pathKey: "/personal_center/park_user/staff_management",
  //   index: "2-5"
  // },
  // {
  //   pathKey: "/personal_center/park_user/admission_to_the_park",
  //   index: "2-6"
  // },
  {
    pathKey: "/personal_center/park_user/feedback_suggestions",
    index: "3-1"
  },
  {
    pathKey: "/personal_center/park_user/customer_center",
    index: "3-2"
  },
  {
    pathKey: "/personal_center/park_user/park_notice",
    index: "3-3"
  }
];
import switchPark from "@/components/dialog/switchPark.vue";
export default {
  components:{
    switchPark
  },
  data() {
    return {
      curActive: "",
      auth: false,
      dialogParams2: {
        dialogVisible: false
      }
    };
  },
  created() {
    this.curActive2();
    this.getAuthenticateEmployees();
  },
  watch: {
    $route(to, form) {
      this.curActive2();
    }
  },
  computed:{
    company() {
      return this.$store.state.company;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  methods: {
    /** 查询认证*/
    getAuthenticateEmployees() {
      let params = {
        status: 'IdentityCertifieStatussuccess'
      };
      this.api.getAuthenticateEmployees(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];
        this.auth = list.length > 0
      });
    },
    curActive2() {
      let path = this.$route.path;
      console.log(this.$route)
      let index = "";
      rouerObj.forEach(item => {
        if (path.indexOf(item.pathKey) > -1) {
          index = item.index;
        }
      });
      if (path === "/personal_center/park_user") {
        index = "1-1";
      }
      if(this.$route.meta.exp.indexOf('我的订单')>-1){
        index = "1-6";
      }
      this.curActive = index;
    }
  }
};
</script>

<style lang="scss">
@import "../index.scss";
.park_user{
  .parkSwitch {
    width: 1200px;
    margin: 0 auto !important;
    padding-top: 20px;
    color: #333;
    font-size: 14px;

    a {
      margin-left: 10px;
      color: #4c84ff;
    }
  }
}
</style>
